import React, { useEffect, useState } from "react";

/**
 * ArcGauge — animated half-circle gauge, 0..max.
 * Matches the "System Health 87/100" reference style.
 */
export const ArcGauge = ({
  value = 0, max = 100, label = "Score", size = 220,
  colorStart = "#2D9CDB", colorEnd = "#C9A84C", testid,
}) => {
  const clamped = Math.max(0, Math.min(value, max));
  const [anim, setAnim] = useState(0);

  useEffect(() => {
    const start = performance.now();
    const from = anim;
    const to = clamped;
    const dur = 900;
    let raf;
    const step = (t) => {
      const p = Math.min(1, (t - start) / dur);
      const eased = 1 - Math.pow(1 - p, 3);
      setAnim(from + (to - from) * eased);
      if (p < 1) raf = requestAnimationFrame(step);
    };
    raf = requestAnimationFrame(step);
    return () => cancelAnimationFrame(raf);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clamped]);

  const pct = anim / max;
  const r = size / 2 - 18;
  const cx = size / 2;
  const cy = size / 2 + 10;
  const circumference = Math.PI * r; // half circle
  const offset = circumference * (1 - pct);
  const id = `grad-${Math.round(pct * 1000)}`;

  return (
    <div className="flex flex-col items-center" data-testid={testid}>
      <svg width={size} height={size / 1.6} viewBox={`0 0 ${size} ${size / 1.6 + 20}`}>
        <defs>
          <linearGradient id={id} x1="0" y1="0" x2="1" y2="0">
            <stop offset="0%" stopColor={colorStart} />
            <stop offset="100%" stopColor={colorEnd} />
          </linearGradient>
        </defs>
        {/* track */}
        <path
          d={`M ${cx - r} ${cy} A ${r} ${r} 0 0 1 ${cx + r} ${cy}`}
          stroke="rgba(201,168,76,0.18)" strokeWidth="14" fill="none" strokeLinecap="round"
        />
        {/* value arc */}
        <path
          d={`M ${cx - r} ${cy} A ${r} ${r} 0 0 1 ${cx + r} ${cy}`}
          stroke={`url(#${id})`} strokeWidth="14" fill="none" strokeLinecap="round"
          strokeDasharray={circumference} strokeDashoffset={offset}
          style={{ filter: "drop-shadow(0 0 8px rgba(45,156,219,0.35))" }}
        />
        <text x={cx} y={cy - 8} textAnchor="middle" className="font-display"
          fill="#F4EFE6" style={{ fontSize: size * 0.26, fontWeight: 700 }}>
          {Math.round(anim)}
        </text>
        <text x={cx} y={cy + 18} textAnchor="middle"
          fill="#8A7333" style={{ fontSize: size * 0.08, letterSpacing: "0.2em" }}>
          / {max}
        </text>
      </svg>
      <div className="text-[11px] uppercase tracking-[0.22em] text-steel mt-1">{label}</div>
    </div>
  );
};

export default ArcGauge;
